module.exports = __webpack_public_path__ + "images/corners/Arrow.882eb4536c6851c9b73275909ce57bff.jpg";